import React from 'react'
import AboutUsItem from '../../Components/About/AboutUsItem/AboutUsItem'
import AboutUsBanner from '../../Components/About/AboutUsBanner/AboutUsBanner'
import SEO from '../../common/SEO/SEO'

const aboutSchema = {
  "@context": "https://schema.org",
  "@type": "AboutPage",
  "name": "About Maya Wears",
  "description": "The philosophy, origins, and craft behind Maya Wears. Designed for those who conquer, crafted in Nepal.",
  "url": "https://mayawears.com.np/about_us",
  "mainEntity": {
    "@type": "Organization",
    "name": "Maya Wears",
    "url": "https://mayawears.com.np",
    "logo": "https://mayawears.com.np/logo-1.webp"
  }
};

function AboutUs() {
  return (
    <div>
      <SEO
        title="About Us | Our Story & Philosophy"
        description="Learn the vision and craftsmanship behind Maya Wears. Creating modern, timeless streetwear in Nepal designed with restraint and made to remain."
        canonical="https://mayawears.com.np/about_us"
        keywords="about Maya Wears, Nepali streetwear brand story, fashion designers Kathmandu, contemporary clothing Nepal"
        schema={aboutSchema}
      />
      <AboutUsBanner/>
      <AboutUsItem/>
    </div>
  )
}

export default AboutUs

